<template>
	<section class="view-feed-container">
		<!-- <ViewFeedTrainer /> -->

		<component
			v-bind:is="item.component"
			v-bind:key="index"
			v-bind="item.props || {}"
			v-for="(item, index) in feedItems"
		/>
	</section>
</template>

<script lang="ts">
	import ViewBase from '@/Core/View.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Feed
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewFeedContainer extends ViewBase {
		/**
		 * Whether the user is authenticated
		 */
		get isAuthenticated(): boolean {
			return this.$store.getters['authentication/authenticated'];
		}

		/**
		 * Dynamically configured feed items
		 *
		 * @type Array
		 */
		get feedItems() {
			return this.$store.getters['settings/feedStructure'].filter(
				(item: any) => item.enabled && (!item.authRequired || this.isAuthenticated),
			);
		}

		/**
		 * Initialize feed items or pull from API in the future
		 *
		 * @return {void}
		 */
		public created(): void {
			// In the future, this could fetch from an API:
			// this.initializeFeedItems();
		}

		/**
		 * Initialize feed items from API (placeholder for future implementation)
		 *
		 * @return {Promise<void>}
		 */
		public async initializeFeedItems(): Promise<void> {
			// API call to get dynamic feed configuration
			// const response = await api.getFeedConfiguration();
			// this.feedItems = response.data;
		}
	}
</script>

<style lang="scss">
	.view-feed-container {
		.view-feed-item {
			margin: 4px 0;

			&:first-child {
				margin-top: 0;
			}

			&:last-child {
				margin-bottom: 0;
			}
		}
	}
</style>
